import './QrCodeListComponent.scss';
import React, {useCallback, useEffect, useState} from 'react';
import {ITableColumn} from "../../../shared/models/table.model";
import SwitchComponent from "../../../shared/components/core/switch/switchComponent";
import CommonService from "../../../shared/services/common.service";
import {IAPIResponseType} from "../../../shared/models/api.model";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {APIConfig, ImageConfig} from "../../../constants";
import {IQrCode} from "../../../shared/models/qrCode.model";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import QrCodeViewComponent from "../../../shared/components/qrcode-viewer/qrCodeViewerComponent";
import TableWrapperV2Component
    from "../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import commonService from "../../../shared/services/common.service";

interface QrCodeListTableComponentProps {
    loggedInUserLocationDetails?: any;
}

const MODULE_NAME = "QrCodeList"

const QrCodeListTableComponent = (props: QrCodeListTableComponentProps) => {

    const {loggedInUserLocationDetails} = props;

    const [filteredColumns, setFilteredColumns] = useState<ITableColumn[]>([]);
    const [openViewQrCodeDrawer, setopenViewQrCodeDrawer] = useState<boolean>(false);
    const [currentQr, setCurrentQr] = useState<any>(null);

    const handleViewQrcodeDrawerClose = useCallback(() => {
        setopenViewQrCodeDrawer(false);
        setCurrentQr(null);
    }, []);

    const handleViewQrcodeDrawerOpen = useCallback((qrImage: any) => {
        setCurrentQr(qrImage);
        setopenViewQrCodeDrawer(true);
    }, []);

    const [columns] = useState<ITableColumn[]>([
        {
            id: 'facilityName', label: 'Facility Name', isDefaultColumn: true,
            fixed:"left",
            width:"230",
            content: (item: IQrCode) => (
                item.facilityDetails ? <>
                    { commonService.capitalizeFirstLetterOfEachWord(item.facilityDetails?.name)}</> : <>-</>
            )
        },
        {
            id: 'locationName', label: 'Location Name', isDefaultColumn: true,
            content: (item: IQrCode) => (
                <>
                    {
                        item.locationDetails ? <>
                            { commonService.capitalizeFirstLetterOfEachWord(item.locationDetails?.name)}</> : <>-</>
                    }
                </>
            )
        },
        {
            id: 'orderingProvider', label: 'Provider',
            isDefaultColumn: true,width:"250",
            content: (item: IQrCode) => (
                <>
                    {
                        item?.physicianDetails ?
                            <>
                                Dr. { commonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.firstName) || '-'} { commonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.middleName) || '-'} { commonService.capitalizeFirstLetterOfEachWord(item?.physicianDetails?.lastName )|| '-'}
                                <br/>
                                NPI: {item?.physicianDetails?.npiNumber || '-'}
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'testName', label: 'Test Name', isDefaultColumn: true,
            content: (item: IQrCode) => (
                <>
                    {
                        item.testDetails ? <>{ commonService.capitalizeFirstLetterOfEachWord(item.testDetails?.name)}</> : <>-</>
                    }
                </>
            )
        },
        {
            id: 'billingMode', label: 'Billing Mode', isDefaultColumn: true,align:"center",
            content: (item: IQrCode) => (
                <>
                    {
                        item.billingMode ? <>{ commonService.capitalizeFirstLetterOfEachWord(item.billingMode)}</> : <>-</>
                    }
                </>
            )
        },
        {
            id: 'createdDate', label: 'Created Date',
            isDefaultColumn: true,align:"center",width:"180",
            content: (item: IQrCode) => (
                <>
                    {
                        item?.createdAt ?
                            <>
                                {commonService.formatDate(item?.createdAt)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.createdAt)} <br/>
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'isActive',
            label: 'Active/Inactive',
            width:"150",
            align:"center",
            isDefaultColumn: true,
            content: (item: IQrCode, index: any) => (
                <React.Fragment>
                    <div>
                        <SwitchComponent
                            size={"small"}
                            checked={item.isActive}
                            onUpdate={() => handleQrCodeToggle(item)}/>
                    </div>
                </React.Fragment>
            )
        },
        {
            id: 'actions',
            label: '',
            isDefaultColumn: true,
            hideInColumnPreferences: true,
            align:"center",
            fixed:"right",
            width:"100",
            content: (item: IQrCode, index: any) => (
                <React.Fragment>
                    <div className="table-actions cursor-pointer"
                         onClick={() => handleViewQrcodeDrawerOpen(item?.imageDetails)}>
                        <div className="table-action">
                            <ChevronRightIcon/>
                        </div>
                    </div>
                </React.Fragment>
            )
        },

    ])


    useEffect(() => {
        if (loggedInUserLocationDetails !== null) {
            // eslint-disable-next-line
            setFilteredColumns(columns.filter((column) => {
                return (!(column.id === 'facilityName' || column.id === 'locationName'))
            }));
        } else {
            setFilteredColumns(columns);
        }
    }, [loggedInUserLocationDetails, columns]);

    const onToggleQrCode = useCallback((item: any) => {
        CommonService._qrcode.toggleQrcode(item.id, {})
            .then((response: IAPIResponseType<any>) => {
                CommonService._communications.TableWrapperRefreshSubject.next({
                    moduleName: MODULE_NAME
                });
                CommonService._alert.showToast(response?.message || `QR Code has been  ${item?.isActive ? "deactivated" : "activated"}`, "success");
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || `Error while ${item?.isActive ? "deactivating" : "activating"} the QR Code`, "error");
            });
    }, []);

    const handleQrCodeToggle = useCallback((item: any) => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: `Are you sure you want to ${item?.isActive ? "deactivate" : "activate"} this QR code?`,
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: `${item?.isActive ? "Deactivate" : "Activate"}`,
                color: "primary",
            },
            no: {
                text: "Cancel",
                color: "primary",
            }
        })
            .then(() => {
                onToggleQrCode(item);
            })
            .catch(() => {
            })
    }, [onToggleQrCode]);


    return (
        <>
            <div className="table-list-container">
                <TableWrapperV2Component
                    isPaginated={true}
                    columns={filteredColumns}
                    url={APIConfig.QR_CODE_LIST.URL}
                    method={APIConfig.QR_CODE_LIST.METHOD}
                    isColumnFilterVisible={true}
                    moduleName={"QrCodeList"}
                />
            </div>
            <DrawerComponent
                open={openViewQrCodeDrawer}
                className={"drawer-wrapper"}
                closeOnBackDropClick={true}
                closeOnEsc={true}
                onClose={() => handleViewQrcodeDrawerClose()}
            >
                <QrCodeViewComponent
                    attachment={currentQr}
                    onClose={() => handleViewQrcodeDrawerClose()}
                />
            </DrawerComponent>
        </>
    )
}
export default QrCodeListTableComponent;
